module.exports = __webpack_public_path__ + "img/projects2.3b737a2e.svg";